import { type FC, useEffect } from 'react'
import { useRotaPatternDescription } from 'screens/Rostering/hooks/useRotaPatternDescription'
import { FrequencyResult } from '../../formComponents'
import type {
  ModalSectionProps,
  RotaPatternFormValues,
  RotaPatternModalType
} from '../utils'

export const FrequencyResultSection: FC<
  ModalSectionProps & { type?: RotaPatternModalType }
> = ({ form, formData, type }) => {
  const hasTimeWindow = formData?.startTime && formData?.endTime

  const { generatePattern, isLoadingGenerate, generatePatternMessage } =
    useRotaPatternDescription({ type })

  const isFormTouched = !!form?.getFieldValue('patternStart')

  // biome-ignore lint/correctness/useExhaustiveDependencies: pre-existing dependency list; changing when this re-runs needs behavioural review
  useEffect(() => {
    if (hasTimeWindow && isFormTouched) {
      generatePattern(formData as unknown as RotaPatternFormValues)
    }
  }, [isFormTouched, formData])

  if (!hasTimeWindow || !generatePatternMessage) {
    return null
  }

  return (
    <FrequencyResult
      message={generatePatternMessage}
      isLoading={isLoadingGenerate}
    />
  )
}
